import { FC, memo } from "react";
import { Controller } from "react-hook-form";
import { TimePickerContainer } from "./TimePicker.style";
import { ITimePicker } from "./TimePicker.types";
// @ts-ignore
import TimePickerCom from "react-time-picker";
import { useTranslation } from "react-i18next";

const TimePicker: FC<ITimePicker> = ({
  control,
  name,
  errors,
  rules,
  label,
}) => {
  const { t } = useTranslation();
  const isRequired = rules?.required;

  return (
    <TimePickerContainer>
      {label && (
        <label className="custom-label">
          {label}
          {isRequired && <span className="required-asterisk" style={{color: "red"}}> *</span>}
        </label>
      )}
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <TimePickerCom
            clockIcon={null}
            clearIcon={null}
            className={`custom-time-picker ${errors[name] ? "error" : ""}`}
            onChange={onChange}
            value={value}
            format="HH:mm"
            hourPlaceholder="HH"
            minutePlaceholder="mm"
            disableClock={true}
          />
        )}
      />
      {errors[name] && (
        <h6 className="text-error">
          {errors[name]?.message || "Majburiy qator!"}
        </h6>
      )}
    </TimePickerContainer>
  );
};

export default memo(TimePicker);